/**
 * Parses distance value for API submission, handling various input formats
 * @param distance - Distance value as string or number
 * @returns Parsed distance as number, or 0 if invalid
 */
export const parseDistanceForApi = (distance: string | number | undefined): number => {
  if (!distance || distance.toString().trim() === '') return 0;
  const normalizedDistance = distance.toString().replace(',', '.');
  const parsed = parseFloat(normalizedDistance);
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Formats distance value for input display (converts dots to commas)
 * @param distance - Distance value to format
 * @returns Formatted distance string for input field
 */
export const formatDistanceForInput = (distance: string | number | undefined): string => {
  if (!distance || distance.toString().trim() === '') return '';
  return distance.toString().replace('.', ',');
};

/**
 * Validates and cleans distance input, allowing only numbers, commas, and dots
 * @param value - Raw input value
 * @returns Cleaned and validated distance string
 */
export const validateDistance = (value: string): string => {
  let result = value.replace(/[^0-9,.]/g, '');
  result = result.replace('.', ',');
  const parts = result.split(',');
  if (parts.length > 2) {
    result = parts[0] + ',' + parts.slice(1).join('');
  }
  // Max 3 digits before comma, 2 after (max 999,99)
  const finalParts = result.split(',');
  if (finalParts.length === 2) {
    result = finalParts[0].slice(0, 3) + ',' + finalParts[1].slice(0, 2);
  } else {
    result = finalParts[0].slice(0, 3);
  }
  return result;
};
